import * as React from "react";
import MuiFormGroup, {
    FormGroupProps as MuiFormGroupProps,
    FormGroupClassKey as MuiFormGroupClassKey
} from "@material-ui/core/FormGroup";

export type FormGroupClassKey = MuiFormGroupClassKey;

export interface FormGroupProps extends MuiFormGroupProps { }

class FormGroup extends React.PureComponent<FormGroupProps> {
    render() {
        const { ...props } = this.props;
        return <MuiFormGroup {...props}>
            {this.props.children}
        </MuiFormGroup>;
    }
}

export default FormGroup; 